import React from "react";
import { connect } from "react-redux";
import { DarkTheme } from "../../../../actions/darkTheme";
import ControlledSwitches from "../../../common/Checked";
import translate from "../../../../i18n/translate";
import "./DarkModeChooser.css";
import { BsSunFill, BsMoonStarsFill } from "react-icons/bs";

const DarkModeChooser = ({ isDarktheme, DarkTheme }) => {
  const handleChange = () => {
    DarkTheme(!isDarktheme);
  };

  return (
    <div className="dark-mode-chooser">
      <div className="dark-mode-option">
        <div className="dark-mode-icon-container light-mode">
          <BsSunFill className="mode-icon sun-icon" />
          <span className="mode-label">{translate("Light Mode")}</span>
        </div>
        <ControlledSwitches check={isDarktheme} Change={handleChange} />
        <div className="dark-mode-icon-container dark-mode">
          <BsMoonStarsFill className="mode-icon moon-icon" />
          <span className="mode-label">{translate("Dark Mode")}</span>
        </div>
      </div>
      <div className="dark-mode-description">
        <p>
          {isDarktheme
            ? translate("Dark mode is enabled. Your eyes will thank you!")
            : translate("Light mode is enabled. Switch to dark mode for better viewing at night.")}
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => ({
  isDarktheme,
});

export default connect(mapStateToProps, { DarkTheme })(DarkModeChooser);

